import { createStore } from "vuex";
import { auth } from "./auth.module";
import { product } from "./product.module";
import { bannerHome } from "./banner.home.module";
import { products } from "./products.module";
import { lancamentos } from "./lancamentos.module";
import { tutoriais } from "./tutoriais.module";
import { modalService } from "./modal.module";
import { bannerLancamentos } from "./banner.lancamentos.module";
import { experiencias } from "./experiencias.module";
import { bannerExperiencia } from "./banner.experiencia.module";
import { user } from "./user.module";
import { members } from "./members.module";
import { tags } from "./tags.module";
import { bannerAproveite } from "./banner.aproveite.module";
import { bannerAtendimento } from "./banner.atendimento.module";
import { bannerAtendimento2 } from "./banner.atendimento2.module";
import { bannerShop } from "./banner.shop.module";
import { faq } from "./faq.module";
import { analytics } from "./analytics.module";
import { socialMedias } from "./social-medias.module";
import { countries } from "./countries.module";
import { contents } from "./contents.module";
import { compositions } from "./compositions.module";
import { highlights } from "./highlights.module";
import { route } from "./route.module"
import { address } from './address.module';
import { discourse } from '@/views/discourse/store/discourse.module.js';
import { files } from './files.module';

const store = createStore({
  modules: {
    auth,
    product,
    bannerHome,
    products,
    lancamentos,
    tutoriais,
    modalService,
    bannerLancamentos,
    experiencias,
    bannerExperiencia,
    user,
    members,
    tags,
    bannerAproveite,
    bannerAtendimento,
    bannerAtendimento2,
    bannerShop,
    faq,
    analytics,
    socialMedias,
    countries,
    contents,
    compositions,
    highlights,
    route,
    address,
    discourse,
    files
  },
});

export default store;
